import React from 'react';
import { IProduct } from '../../../stores';
import ProductCustomers from './ProductCustomers';

const ProductStatistics = ({ product }: { product: IProduct }) => {
  return (
    <>
      {/*<Section title={intl.formatMessage({ defaultMessage: 'Statistics' })}>
        <Box is="p" className="muted">
          <FormattedMessage defaultMessage="Nothing to show yet" />
        </Box>
  </Section>*/}

      <ProductCustomers product={product} />
    </>
  );
};

export default ProductStatistics;
